import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/page-header';
import { usePerformanceReviewAccess } from '../hooks';

/**
 * Read-only review view. Placeholder shell wired to the route in this story;
 * the rendered sections land with the detail story.
 */
const PerformanceReviewDetail: React.FC = () => {
  const { t } = useTranslation('performanceReview');
  const canView = usePerformanceReviewAccess();

  if (!canView) {
    return null;
  }

  return (
    <div>
      <PageHeader title={t('detail.title')} testId="performance-review-detail" />
    </div>
  );
};

export default PerformanceReviewDetail;
